import { render, staticRenderFns } from "./SelectArticle.vue?vue&type=template&id=615f4c70&scoped=true"
import script from "./SelectArticle.vue?vue&type=script&lang=js"
export * from "./SelectArticle.vue?vue&type=script&lang=js"
import style0 from "./SelectArticle.vue?vue&type=style&index=0&id=615f4c70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615f4c70",
  null
  
)

export default component.exports